import type {AddMaterialDescriptionFormPayload} from "./add-material-description.schema";

import {addMaterialDescription} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function addMaterialDescriptionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: materialMutationKeys.addMaterialDescription,
    mutationFn: (payload: AddMaterialDescriptionFormPayload) => addMaterialDescription(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
